<h3 mat-dialog-title>{{ heading }}</h3>
<div>
    <div *ngFor="let message of messages; let i = index" mat-dialog-content>
        <b *ngIf="messageTitle && messageTitle[i] && messageTitle.length">{{
            messageTitle[i] | translate
        }}</b>
        <span [innerHTML]="message | translate"></span>
    </div>
</div>

<div mat-dialog-actions>
    <button *ngIf="confirmation" mat-button mat-dialog-close (click)="sureDialogue()">
        {{ "GENERAL.SURE" | translate }}
    </button>
    <button mat-button mat-dialog-close (click)="closeDialogue()">
        {{ "GENERAL.CLOSE" | translate }}
    </button>
</div>
